import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ConfirmationModalPopupComponent } from 'src/app/core/confirmation-modal-popup/confirmation-modal-popup.component';
import { HaloCustomLoaderErrorType } from 'src/app/core/halo-custom-loader/halo-custom-loader.service';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { ESupportType, SuperFooterService } from 'src/app/core/services/super-footer.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { FileSizeUtil, Units } from 'src/app/core/Utils/fileSizeUtil';
import { PageTitleService } from 'src/app/post-login/services/page-title.service';
import { StaffService } from 'src/app/post-login/services/staff.service';
import { environment } from 'src/environments/environment';
import { ServicePageService } from '../../service.service';

@Component({
  selector: 'app-job-order',
  templateUrl: './job-order.component.html',
  styleUrls: ['./job-order.component.scss']
})
export class JobOrderComponent implements OnInit {
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;
  assigneeList: any[] = [];
  assetList: any;
  assetListTemp: any;
  currentFacility: FacilityObject;
  action: string | undefined | null;
  id: string | undefined | null;
  jobInfo: any = {type: 'Cardio', status: 'Open'};
  dueDate: NgbDateStruct;
  showDeleteMsg = false;
  customLoaderIsLoading = false;
  customLoaderErrorMsg: string;
  showCompleteModal = false;

  deleteModalProps = {
    title: `${this.commonUtil.translateText('Delete Attachment')}?`,
    message: 'DELETE.ATTACHMENT.MSG',
    isWarningPopup: true,
    ctaButtonLabel: 'YES',
    negativeButtonLabel: 'NO',
    isCloseIconCallsCta: false
  };

  private sub = new Subscription();
  private deleteMsg: string;
  private currentPage = 1;
  private rowsPerPage = 5;

  @ViewChild(ConfirmationModalPopupComponent) modalComponent: ConfirmationModalPopupComponent;
  constructor(
    private commonUtil: CommonUtil,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private staffService: StaffService,
    private facilityService: FacilityService,
    private supportService: SuperFooterService,
    private amplitudeAnalytics: AmplitudeAnalyticsService,
    private pageTitleService: PageTitleService,
    private service: ServicePageService,
    private toast: HaloToastService,
    private fileSizeUtil: FileSizeUtil
  ) { }

  async ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;
    this.rootScopeData = this.commonUtil.rootScopeData;
    this.action = this.route.snapshot.paramMap.get('action');
    this.id = this.route.snapshot.paramMap.get('id');
    this.currentFacility = this.facilityService.selectedFacility();
    const facilityChange = this.facilityService.selectedFacilitySource.subscribe((res) => {
      this.location.back();
    });
    this.sub.add(facilityChange);
    if (this.action ==='add'){
      const date = new Date();
      this.jobInfo.dueDate = date.getTime();
      this.dueDate = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    }
    this.getData();
    setTimeout(() => this.pageTitleService.setTitle(''));
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getCurrentDate(date: NgbDateStruct) {
    if(!this.dueDate || !(date.year === this.dueDate.year && date.month === this.dueDate.month && date.day === this.dueDate.day)) {
      this.dueDate = date;
      const d = new Date(date.year, date.month-1, date.day);
      setTimeout(() => this.jobInfo.dueDate = d.getTime());
      this.onEdit();
    }
  }

  onJobTypeChanged(type: string) {
    if(type === this.jobInfo.type) return;
    this.jobInfo.type = type;
    this.jobInfo.assets = [];
    this.getAssets(type);
    this.onEdit();
  }

  onStatusChanged(status: string) {
    if(status === this.jobInfo.status) return;
    this.jobInfo.status = status;
    this.onEdit();
  }

  onEdit() {
    this.rootScopeData.isPageHasUnsavedChanges = true;
  }

  onCancel() {
    if(this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.pathToNavigate = '/service/maintenance';
      this.rootScopeData.showUnSavedChangesModal = true;
    } 
    else this.location.back();
  }

  onDeleteFile(file: any) {
    this.deleteModalProps.message = this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.ATTACHMENT.MSG', [file.name]);
    this.showDeleteMsg = true;
    const fileIdx = this.jobInfo.files.findIndex((f: any) => f == file);
    if(fileIdx < 0) return;
    // allow the current process to end before processing the showing of modal
    setTimeout(() => {            
      this.modalComponent.show(true).then(async res => {
        this.showDeleteMsg = false;
        if(res == 1) {// YES
          const file: any = this.jobInfo.files[fileIdx];
          if(!file.uploadedFile) this.jobInfo.files.splice(fileIdx, 1);
          else file.isDeleted = true;
          this.onEdit();
        }
      });
    });
  }

  onAssigneeChanged(user: any) {
    this.jobInfo.userid = user.text;
    this.jobInfo.userEmail = user.emailAddress;
    this.jobInfo.assigneeId = user.userId;
  }

  onUpdate() {
    if(this.jobInfo.status === 'Closed') {
      this.showCompleteModal = true;
      return;
    }
    this.update();
  }

  private async update(){
    const formData = new FormData();
    const inputVO: any = {
      "facilityId": this.currentFacility.facilityId,
      "userId": this.rootScopeData.currentUser.userId,
      "name": this.jobInfo.jobName,
      "dueDate": this.jobInfo.dueDate,
      "status": this.jobInfo.status,
      "type": this.jobInfo.type,
      "assets": this.jobInfo.assets?.map((a:any) =>{
        const res: any = { name: a.name };
        if(a.id) res.id = a.id;
        return res;
      }),
      "description": this.jobInfo.description,
      "assigneeId": this.jobInfo.assigneeId
    };
    this.jobInfo.files?.forEach((f:any) => {
      if(f.isDeleted) {
        if(!inputVO.deletedFiles) inputVO.deletedFiles = [];
        inputVO.deletedFiles.push({name: f.name});
      } else if(f.downloadUrl) {
        if(!inputVO.files) inputVO.files = [];
        inputVO.files.push({
          "downloadUrl": f.downloadUrl,
          "name": f.name,
          "size": f.size,
          "type": f.type
        });
      } else if(f.uploadedFile) {
        formData.append('files', f.uploadedFile)
      }
    });
    if(this.id) inputVO.jobOrderId = this.id;
    if(this.jobInfo.status === 'Closed') {
      inputVO.notes = this.jobInfo.notes;
      inputVO.userEmail = this.jobInfo.userEmail;
      inputVO.completedDate = this.jobInfo.completedDate;
      inputVO.completedUserEmail = this.jobInfo.completedUserEmail;
    }
    formData.append('inputVO', new Blob([JSON.stringify(inputVO)], {type: 'application/json'}));
    this.customLoaderIsLoading = true;
    try {
      let toast = this.commonUtil.translateText('JOB.ORDER.CREATED');
      if(this.id) {
        this.jobInfo = await this.service.updateJobOrder(formData);
        toast = this.commonUtil.translateText('JOB.ORDER.UPDATED');
      } else {
        this.jobInfo = await this.service.addJobOrder(formData);
        this.action = 'view';
        this.id = this.jobInfo.id;
      }
      if(this.jobInfo.status === 'Closed') toast = this.commonUtil.translateText('JOB.ORDER.CLOSED');
      this.toast.creatToast(toast);
      this.rootScopeData.isPageHasUnsavedChanges = false;
      this.processJobInfo();
    } catch (error) {
      console.error('API failed.');
    }
    this.customLoaderIsLoading = false;
  }

  onRequestSupport() {
    this.supportService.switchForm(ESupportType.TECHNICIAN_VISIT);
  }

  onOrderParts() {
    this.amplitudeAnalytics.logEvent({elementName: 'Order Parts', action: 'Click'}, 'Order Parts');
    if (localStorage.getItem('ssoFederated') != null && localStorage.getItem('ssoFederated') == 'true') {
      window.open(environment.ssoPartsUrl + '/OA_HTML/ibeCAcpSSOLogin.jsp', '_blank');
    } else {
      window.open(environment.ssoPartsUrl + '/OA_HTML/ibeCZzpHome.jsp', '_blank');
    }
  }

  onAssetsChange(asset: any) {
    if (asset.text === '' || this.jobInfo.assets?.includes(asset)) return;
    if (!this.jobInfo.assets) this.jobInfo.assets = [];
    this.jobInfo.assets.push(asset);
    this.refreshAssetList();
    this.onEdit();
  }

  onAddAsset(asset: any) {
    const newAsset = {name: asset, text: asset};
    this.assetList.push(newAsset);
    this.assetListTemp.push(newAsset);
  }

  onRemoveAsset(asset: any) {
    this.jobInfo.assets = this.jobInfo.assets.filter((j:any) => j !== asset);
    this.refreshAssetList();
    this.onEdit();
  }

  onAddFile(files: FileList) {
    for (let index = 0; index < files.length; index++) {
      const file = files.item(index);
      if(file && file.size > this.fileSizeUtil.toByteSize(10, Units.MB)) {
        this.jobInfo.isFileError = true;
      } else if (file) {
        const newFile = {name: file.name, size: file.size, type: file.type, byteSize: this.fileSizeUtil.toByteSizeDisplay(file.size), uploadedFile: file }
        if (!this.jobInfo.files) this.jobInfo.files = [];
        this.jobInfo.files.push(newFile);
        this.onEdit();
      }
    }
  }

  async addComment() {
    const payload = {
      author: this.rootScopeData.currentUser.displayName,
      createdDate: Date.now(),
      facilityId: this.currentFacility.facilityId,
      jobOrderId: this.id,
      text: this.jobInfo.comment,
      userId: this.rootScopeData.currentUser.userId
    }
    try {
      const comments = await this.service.addComment(payload);
      this.jobInfo.comment = '';
      this.jobInfo.commentAuthors = comments;
      this.jobInfo.commentAuthors?.forEach((c:any) => c.userAvatar = this.assigneeList?.find(a => c.userId == a.userId)?.thumbnailUrl);
    } catch (error) {
      console.error('API failed.');
    }
  }

  paginationChanged(event: any) {
    if (!event) return;
    this.currentPage = event.currentPage;
    this.rowsPerPage = event.rowsPerPage;
    setTimeout(() => {
      this.filterComments();
    });
  }

  async onDeleteJobOrder() {
    this.customLoaderIsLoading = true;
    if(!this.id) return;
    try {
      await this.service.deleteJobOrder(this.currentFacility.facilityId, this.id, this.rootScopeData.currentUser.emailAddress.toString());
      this.toast = this.commonUtil.translateText('JOB.ORDER.DELETED');
    } catch (error) {
      console.error('API failed.');
    }
    this.customLoaderIsLoading = false;
    this.rootScopeData.isPageHasUnsavedChanges = false;
    this.onCancel();
  }
  
  async onCompleted(data: any) {
    this.showCompleteModal = false;
    this.jobInfo.notes = data.notes;
    this.jobInfo.userEmail = this.rootScopeData.currentUser.emailAddress;
    this.jobInfo.completedDate = data.completedTimestamp;
    this.jobInfo.completedUserEmail = data.userEmail;
    this.update();
  }

  private filterComments() {
    const startIndex = (this.currentPage - 1) * this.rowsPerPage;
    let endIndex = this.currentPage * this.rowsPerPage;
    endIndex = this.jobInfo.commentAuthors.length > endIndex ? endIndex : this.jobInfo.commentAuthors.length;
    this.jobInfo.filteredComments = [];
    for (let index = startIndex ; index < endIndex; index++) {
      this.jobInfo.filteredComments.push(this.jobInfo.commentAuthors[index]);
    }
  }

  private async getData() {
    this.customLoaderIsLoading = true;
    try {
      const promiseList = [];
      promiseList.push(this.getManagerList());
      if(this.action !== 'add') promiseList.push(this.getJobOrder());
      await Promise.all(promiseList);
      if(this.action !== 'add') this.processJobInfo();
      await this.getAssets(this.jobInfo.type);
      this.customLoaderIsLoading = false;
    } catch (error) {
      console.error('API failed.');
      this.customLoaderErrorMsg =  HaloCustomLoaderErrorType.APIFAILED;
    }
  }

  private async getJobOrder() {
    if(!this.currentFacility || !this.id) return;
    this.jobInfo = await this.service.getJobOrder(this.currentFacility.facilityId, this.id);
  }

  private processJobInfo() {
    if(this.jobInfo) {
      if(this.jobInfo?.dueDate) {
        const d = new Date(this.jobInfo.dueDate);
        this.dueDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
      }
      this.jobInfo.assets = this.jobInfo.jobTypeVO?.jobs;
      this.jobInfo.type = this.jobInfo.jobTypeVO?.jobType??'Cardio';
      this.jobInfo.userid = this.jobInfo.assigneeVO?.displayName;
      this.jobInfo.userEmail = this.jobInfo.assigneeVO?.email;
      this.jobInfo.assigneeId = this.jobInfo.assigneeVO?.id;
      this.jobInfo.commentAuthors?.forEach((c:any) => c.userAvatar = this.assigneeList?.find(a => c.userId == a.userId)?.thumbnailUrl);
      this.jobInfo.files?.forEach((f:any) => f.byteSize = this.fileSizeUtil.toByteSizeDisplay(f.size));
      this.filterComments();
    }
  }

  private refreshAssetList() {
    if(!this.jobInfo?.assets) this.assetListTemp = this.assetList;
    else this.assetListTemp = this.assetList.filter((a:any) => !this.jobInfo.assets.find((f:any)=> a.id==f.id&&a.name==f.name));
  }

  private async getManagerList() {
    if (this.currentFacility.facilityId) {
      const data = await this.staffService.getList(this.currentFacility.facilityId).toPromise();
      this.assigneeList = data.manager.map((m:any) => {
        m.text = `${m.firstName} ${m.lastName}`;
        m.value = m.userId;
        return m;
      });
    }
  }

  private async getAssets(type: string) {
    this.assetListTemp = this.assetList = [];
    this.assetList = await this.service.getAssets(this.currentFacility.facilityId, type);
    this.assetList?.forEach((a:any) => {
      a.text = a.name; 
      a.value = a.id; 
    });
    this.refreshAssetList();
  }
}
